<template>
  <div class="modal is-active">
    <div class="modal-background" @click="emit('cancel')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <slot name="title"></slot>
        <button v-on:click="emit('cancel')" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <slot name="body"></slot>
      </section>

      <footer class="modal-card-foot">
        <slot name="buttons"></slot>
      </footer>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'cancel'): void;
}>();
</script>

<style lang="scss">
.modal-card-foot {
  .btn {
    &:not(:last-child) {
      margin-right: 0.5em;
    }
  }
}
</style>
